import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import * as api from "../api";
import Message from "./Message";


const PREFIX = "MessageGroup";

const classes = {
	root: `${PREFIX}root`,
	divider: `${PREFIX}divider`,
	title: `${PREFIX}title`,
	messages: `${PREFIX}messages`,
};

const StyledGrid = styled(Grid)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		flexShrink: 0,
		flexWrap: "nowrap",
		width: "100%",
		"&:last-child": {
			paddingTop: theme.spacing(2),
		},
	},

	[`& .${classes.divider}`]: {
		backgroundColor: grey[400],
		position: "relative",
		width: "100%",
		top: "18px",
	},

	[`& .${classes.title}`]: {
		alignSelf: "center",
		backgroundColor: "#FFFFFF",
		border: STANDARD_BORDER_STYLE,
		borderRadius: "13px",
		boxShadow: "0px 1px 3px 0px rgba(0,0,0,0.10)",
		fontSize: "12px",
		fontWeight: "bold",
		height: "auto",
		lineHeight: "15px",
		marginBottom: theme.spacing(3),
		padding: "5px 10px",
		position: "sticky",
		top: theme.spacing(2),
		width: "fit-content",
		zIndex: 1,
	},

	[`& .${classes.messages}`]: {
		flexShrink: 0,
		flexWrap: "nowrap",
		width: "100%",
	},
}));

interface Props {
	channelId: string;
	group: api.MessageGroup;
}


const MessageGroup: React.FunctionComponent<Props> = ({ channelId, group }) => {
	const dateFormatOptions: Intl.DateTimeFormatOptions = { weekday: "long", month: "long", day: "numeric" };
	const groupTitle = group.date.toLocaleDateString(undefined, dateFormatOptions);


	return (
		<StyledGrid
			className={classes.root}
			container
			direction="column"
			item
		>
			<Divider className={classes.divider} />
			<div className={classes.title}>{groupTitle}</div>
			<Grid
				className={classes.messages}
				container
				direction="column-reverse"
				item
			>
				{
					group.messages.map((message) => (
						<Message
							channelId={channelId}
							key={message.ts + message.user}
							message={message}
						/>
					))
				}
			</Grid>
		</StyledGrid>
	);
};

export default MessageGroup;